<template>
    <div class="container">
         <div class="d-flex justify-content-center">
            <img src="@/assets/azeem.jpg" alt="My Image" class="mr-2 user-image" >
            <p class="hello-text">Say Hello</p>
        </div>

        <hr class="hr-line">
            <div class="d-flex justify-content-center">
                <div class="m-3">
                    <a href="mailto:adenugaazeem80@gmail.com" target="_blank" rel="noopener noreferrer">   
                        <p>
                            <i class="bi bi-envelope-fill contact-icon"></i>
                        </p>
                    </a>
                </div>
                <div class="m-3">
                    <a href="https://www.linkedin.com/in/adenugaazeem" target="_blank" rel="noopener noreferrer">
                        
                        <p>
                            <i class="bi bi-linkedin contact-icon"></i>
                        </p>
                    </a>
                </div>
                <div class="m-3">
                    <a href="https://twitter.com/azeemade" target="_blank" rel="noopener noreferrer">
                        
                        <p>
                            <i class="bi bi-twitter contact-icon"></i>
                        </p>
                    </a>
                </div>
                <!-- <div class="m-3">
                    <a href="https://dribbble.com/azeemade" target="_blank" rel="noopener noreferrer">
                        
                        <p>
                            <i class="bi bi-linkedin contact-icon"></i>
                        </p>
                    </a>
                </div> -->
                <div class="m-3">
                    <a href="https://github.com/azeemade" target="_blank" rel="noopener noreferrer">
                        
                        <p>
                            <i class="bi bi-github contact-icon"></i>
                        </p>
                    </a>
                </div>
            </div>
        <div class="d-flex justify-content-center">
            <button class="contact-icon btn">
                <a href="https://open.spotify.com/user/azeembaba?si=9d77de42f3f14402" target="_blank" rel="noopener noreferrer">
                    <i class="bi bi-spotify mr-2"></i>
                    Checkout my playlists
                </a>
            </button>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Contact',
}
</script>

<style>
    .hello-text{
        text-align: center;
        color: #949495;
        font-size: x-large;
    }
    .hr-line{
        background-color: #949495;
    }
    .contact-icon{
        padding: 0.5rem;
        border-radius: 4px;
        background: #202022;
    }
    .m-3 a{
        color: #949495;
    }
    .user-image{
        border-radius: 50%;
        width: 50px;
        height: 50px;
        object-fit: cover;
    }
    .contact-icon a{
        color: #949495;
    }
</style>